export default __webpack_public_path__ + "static/media/delete-account.3a74916c.mp4";